import React, { lazy, Suspense } from "react"
import { BrowserRouter, Switch, Route } from "react-router-dom"
import "./App.css"
import DataStore from "./components/dataStore/DataStore"
import ShareResultComponent from "./components/shareResult/ShareResultComponent"

const MainComponent = lazy(() => import("./components/main/MainComponent"))

function App() {
  return (
    <Suspense fallback="loading">
      <BrowserRouter>
        <Switch>
          <DataStore.Provider>
            <Route exact path={`/`}>
              <MainComponent> </MainComponent>
            </Route>
            <Route path={"/shareResult"}>
              <ShareResultComponent></ShareResultComponent>
            </Route>
          </DataStore.Provider>
        </Switch>
      </BrowserRouter>
    </Suspense>
  )
}

export default App
